

export default {
  data: () => ({
    mes: null,
    snackbar: false,
  }),
  computed: {
    mesVigente() {
      let year = new Date().getFullYear();
      let month = new Date().getMonth();
      return `${year}-${month + 1}`;
    },
  },

  methods: {
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "relatorio.csv"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    downloadCsv() {
      this.$http
        .get(`/relatorio/vendas/csv`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          this.forceFileDownload(response);
        })
        .catch(() => (this.snackbar = true));
    },
    downloadCsvMes() {
      let mes = this.mes.split("-")[1];
      let ano = this.mes.split("-")[0];
      let data = mes + "-" + ano;

      this.$http
        .get(`/relatorio/vendas/csv/${data}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          this.forceFileDownload(response);
        })
        .catch(() => (this.snackbar = true));
    },
  },
};
